/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Format_HInputs */

const en_wc_tut_format_h = /** @type {(inputs: Wc_Tut_Format_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Format text and use Styles`)
};

/**
* | output |
* | --- |
* | "3. Format text and use Styles" |
*
* @param {Wc_Tut_Format_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_format_h = /** @type {((inputs?: Wc_Tut_Format_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Format_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_format_h(inputs)
});
export { wc_tut_format_h as "wc.tut.format.h" }